import Box from '@mui/material/Box'
import { default as MUICircularProgress } from '@mui/material/CircularProgress'

const CircularProgress = ({ height = 300, width = '100%' }) => (
  <Box
    sx={{
      height,
      width,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <MUICircularProgress />
  </Box>
)

export default CircularProgress
